import TrIIIbe from './components/TrIIIbe';

/**
 * Root component.
 *
 * Phase 1 (current): renders TrIIIbe directly (no auth required).
 * Phase 2: add Supabase auth gating.
 */
export default function App() {
  return <TrIIIbe />;
}
